var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1 row-pointer",attrs:{"headers":_vm.headers,"items":_vm.translations,"item-key":"name"},on:{"click:row":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }